import React from 'react'
import { rhythm } from '../utils/typography'
import get from "lodash/get"
import Link from 'gatsby-link'


export default class BlogList extends React.Component {
  render() {
    const pageLinks = []
    const siteTitle = get(this, "props.data.site.siteMetadata.title")
    const posts = get(this, "props.data.allMarkdownRemark.edges")
    posts.forEach(post => {
      if (post.node.fields.slug.match(/^\/blogpost\//)) {
        const title = get(post, "node.frontmatter.title") || post.node.fields.slug
        const desc = get(post, "node.frontmatter.description");
        const date = get(post, "node.frontmatter.date");
        pageLinks.push(
          <li
            key={post.node.frontmatter.path}
            style={{
              marginBottom: rhythm(1 / 4),
            }}
          >
            <Link style={{ boxShadow: "none" }} to={post.node.fields.slug}>
              {post.node.frontmatter.title}
            </Link><br />{desc}
          </li>
        )
      }
    })

    return (
      <ul>
        {pageLinks}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BlogList.js